import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CategoryIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CategoryIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.48474 11.3189H5.83429C4.82299 11.3189 4 10.4959 4 9.48461V5.83425C4 4.82297 4.82299 4 5.83429 4H9.48474C10.496 4 11.319 4.82297 11.319 5.83425V9.48461C11.319 10.4959 10.496 11.3189 9.48474 11.3189ZM5.83429 5.21023C5.49036 5.21023 5.21025 5.49033 5.21025 5.83425V9.48462C5.21025 9.82854 5.49036 10.1086 5.83429 10.1086H9.48474C9.82867 10.1086 10.1088 9.82854 10.1088 9.48462V5.83425C10.1088 5.49033 9.82867 5.21023 9.48474 5.21023H5.83429Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1657 20H14.5153C13.504 20 12.681 19.177 12.681 18.1654V14.5154C12.681 13.5037 13.504 12.6807 14.5153 12.6807H18.1657C19.177 12.6807 20 13.5037 20 14.5154V18.1654C20 19.177 19.177 20 18.1657 20ZM14.5153 13.891C14.1713 13.891 13.8912 14.1711 13.8912 14.5154V18.1654C13.8912 18.5097 14.1713 18.7898 14.5153 18.7898H18.1657C18.5096 18.7898 18.7897 18.5097 18.7897 18.1654V14.5154C18.7897 14.1711 18.5096 13.891 18.1657 13.891H14.5153Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.48474 20H5.83429C4.82299 20 4 19.177 4 18.1654V14.5154C4 13.5037 4.82299 12.6807 5.83429 12.6807H9.48474C10.496 12.6807 11.319 13.5037 11.319 14.5154V18.1654C11.319 19.177 10.496 20 9.48474 20ZM5.83429 13.891C5.49036 13.891 5.21025 14.1711 5.21025 14.5154V18.1654C5.21025 18.5097 5.49036 18.7898 5.83429 18.7898H9.48474C9.82867 18.7898 10.1088 18.5097 10.1088 18.1654V14.5154C10.1088 14.1711 9.82867 13.891 9.48474 13.891H5.83429Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1657 11.3189H14.5153C13.504 11.3189 12.681 10.4959 12.681 9.48461V5.83425C12.681 4.82297 13.504 4 14.5153 4H18.1657C19.177 4 20 4.82297 20 5.83425V9.48461C20 10.4959 19.177 11.3189 18.1657 11.3189ZM14.5153 5.21022C14.1713 5.21022 13.8912 5.49032 13.8912 5.83425V9.48461C13.8912 9.82853 14.1713 10.1086 14.5153 10.1086H18.1657C18.5096 10.1086 18.7897 9.82853 18.7897 9.48461V5.83425C18.7897 5.49032 18.5096 5.21022 18.1657 5.21022H14.5153Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CategoryIcon;
